import { render, staticRenderFns } from "./myProducts.vue?vue&type=template&id=2e5814aa"
import script from "./myProducts.vue?vue&type=script&lang=js"
export * from "./myProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserLinks: require('/vercel/path0/components/userLinks.vue').default})
